export default __webpack_public_path__ + "static/media/AQR-token-utility.50258ed9.png";